import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import { useMemo, useState } from 'react';

type DownloadBlobResponse = {
  download: () => Promise<void>;
  isFetching: boolean;
};

export const useDownloadBlob = (uri: string, filename: string): DownloadBlobResponse => {
  const [isFetching, setIsFetching] = useState(false);

  const download = async () => {
    setIsFetching(true);
    const response = await fetch(uri);
    if (!response.ok) {
      setIsFetching(false);
      throw new Error(`Failed to download file: ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();
    const timestamp = dayjs().format('HH-mm_DD-MM-YYYY');
    saveAs(blob, `${timestamp}-${filename}`);
    setIsFetching(false);
  };

  const response = useMemo(() => ({ download, isFetching }), [uri, filename]);
  return response;
};
